import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import Box from '@mui/material/Box';

const imgtypeList = [

    {'id' : 0, 'name' : 'portrait', 'title' : 'Portrait'},
    {'id' : 1, 'name' : 'landscape', 'title' : 'Langscape'},

]


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [title, setTitle] = useState("")

  const [description, setDescription] = useState("")

  const [coin, setCoin] = useState("")

  const [price, setPrice] = useState("")

  const [imgactive, setImgactive] = useState("")

  const [imginactive, setImginactive] = useState("")

  const [status, setStatus] = useState("active")

  const [redeemStatus, setRedeemStatus] = useState(false)

  const [externalStatus, setExternalStatus] = useState(false)

  const [imgtype, setImgtype] = useState("portrait")

  const [width, setWidth] = useState("")

  const [height, setHeight] = useState("")

  const [createdAt, setCreatedAt] = useState(new Date())

  const [ perc, setPerc ] = useState(null)
  
  const [activefile, setactivefile ] = useState("")

  const [inactivefile, setinactivefile ] = useState("")

  const [rewardImage, setRewardImage] = useState("")

  const [errorTitle, setErrorTitle] = useState(false)

  const [errorDescription, setErrorDescription] = useState(false)

  const [errorCoin, setErrorCoin] = useState(false)

  const [errorPrice, setErrorPrice] = useState(false)

  const [errorWidth, setErrorWidth] = useState(false)

  const [errorHeight, setErrorHeight] = useState(false)

  const [errorImgtype, setErrorImgtype] = useState(false)

  const [errorimgactive, setErrorimgactive] = useState(false)

  const [errorimginactive, setErrorimginactive] = useState(false)

  const navigate = useNavigate();



  
  useEffect(() => {

      // setIsloading(true)

      const uploadActiveFile = () => {
  
        const name = new Date().getTime() + activefile.name;
        
        const storageRef = ref(storage, "loayaltyRewardImages/"+name);
  
        const uploadTask = uploadBytesResumable(storageRef, activefile);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            setPerc('Upload is ' + progress.toFixed(0) + '% complete')
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              // set((prev) => ({...prev, img: downloadURL}))
              setImgactive(downloadURL)

              // setIsloading(false)

            });
          }
        );
  
      };
  
      activefile && uploadActiveFile();
  
  }, [activefile]);

   
  useEffect(() => {

      // setIsloading(true)

      const uploadInactiveFile = () => {
  
        const name = new Date().getTime() + inactivefile.name;
        
        const storageRef = ref(storage, "loayaltyRewardImages/"+name);
  
        const uploadTask = uploadBytesResumable(storageRef, inactivefile);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            setPerc('Upload is ' + progress.toFixed(0) + '% complete')
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              // set((prev) => ({...prev, img: downloadURL}))
              setImginactive(downloadURL)

              // setIsloading(false)

            });
          }
        );
  
      };
  
      inactivefile && uploadInactiveFile();
  
  }, [inactivefile]);




   
    const deleteactiveImage = () => {
  
       const deleteRef = ref(storage, imgactive);
      
              // Delete the file
          deleteObject(deleteRef)

          setImgactive("")
  
          setactivefile("")
  
          // .then(async() => {
      
      
          //     const delRef = doc(db, 'loyaltyReward', rewardId);
      
          //     // Remove the 'capital' field from the document
          //     await updateDoc(delRef, {
  
          //         imgactive: deleteField()
  
          //     });
  
          //     setImgactive("")
  
          //     setactivefile("")
  
        
          // }).catch((error) => {
          //     // Uh-oh, an error occurred!
          //     console.log(error)
          // });
    }
  
  
  
     const deleteinactiveImage = () => {
  
       const deleteRef = ref(storage, imginactive);
      
              // Delete the file
          deleteObject(deleteRef)

          setImginactive("")
  
          setinactivefile("")
  
          // .then(async() => {
      
      
          //     const delRef = doc(db, 'loyaltyReward', rewardId);
      
          //     // Remove the 'capital' field from the document
          //     await updateDoc(delRef, {
  
          //         imginactive: deleteField()
  
          //     });
  
          //     setImginactive("")
  
          //     setinactivefile("")
  
        
          // }).catch((error) => {
          //     // Uh-oh, an error occurred!
          //     console.log(error)
          // });
    }




  // const deleteinactiveUrl  = () => {

  //       const deleteRef = ref(storage, rewardImage);
    
  //           // Delete the file
  //       deleteObject(deleteRef)

  //       setImginactive("")

  //       setinactivefile("")

    
  // }

  
    
    const handleRewards = async(e) => {
  
      e.preventDefault()

      if(title === ""){
        
        return setErrorTitle("Title is required")
      }

       if(description === ""){
        
        return setErrorDescription("Description is required")
      }

       if(coin === ""){
        
        return setErrorCoin("Coin is required")
      }

       if(price === ""){
        
        return setErrorPrice("price is required")
      }

       if(width === ""){
        
        return setErrorWidth("Width is required")
      }

       if(height === ""){
        
        return setErrorHeight("Height Photo is required")
      }

        if(imgtype === ""){
        
        return setErrorImgtype("Height Photo is required")
      }

      
      setIsloading(true)
  
      try{
           
         const advertResponse = await addDoc(collection(db, "loyaltyReward"), {
        
          title: title,
          description: description,
          coin: Number(coin),
          price: Number(price),
          height: Number(height),
          width: Number(width),
          imgactive: imgactive,
          imginactive: imginactive,
          status: status,
          imgtype: imgtype,
          redeemStatus: redeemStatus,
          externalStatus: externalStatus,
          createdAt : today,
          
        });

        navigate("/reward")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handleTitle = (e) => {

         setTitle(e.target.value)

         if(title !== ""){

          setErrorTitle(false)
          
         }

    }

    
    const handleDescription = (e) => {

         setDescription(e.target.value)

         if(description !== ""){

          setErrorDescription(false)
          
         }

    }


      const handleCoin = (e) => {


        
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

          setCoin(onlyNums)

         if(coin !== ""){

          setErrorCoin(false)
          
         }

    }


    const handlePrice = (e) => {

         const { value } = e.target;

         const onlyNums = value.replace(/[^0-9]/g, ''); 

         setPrice(onlyNums)

         if(price !== ""){

          setErrorPrice(false)
          
         }

    }


    useEffect(() => {


      if(imgtype === "portrait"){

        setWidth(70)
        setHeight(70)

      }else{

        setWidth(80)
        setHeight(60)

      }


    }, [imgtype])


    //   const handleWidth = (e) => {

    //      const { value } = e.target;

    //      const onlyNums = value.replace(/[^0-9]/g, ''); 

    //      setWidth(onlyNums)

    //      if(width !== ""){

    //       setErrorWidth(false)
          
    //      }

    // }


    // const handleHeight = (e) => {

    //      const { value } = e.target;

    //      const onlyNums = value.replace(/[^0-9]/g, ''); 

    //      setHeight(onlyNums)

    //      if(height !== ""){

    //       setErrorHeight(false)
          
    //      }

    // }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Reward</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/reward"
            >
              Reward List
            </Link>
            <Typography color="green">New Reward</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


                    <div style={{width:'49%', flexDirection:'column'}}>
                      
                      <p style={{fontSize:18, fontWeight:600, color:'#333', marginBottom:10}}>Title</p>

                       <TextField
                            type="text"
                            name="title"
                            placeholder="Enter Title"
                            value={title}
                            onChange={handleTitle}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorTitle &&

                            <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

                          }

                    </div>

                    <div style={{width:'49%', flexDirection:'column'}}>

                      <p style={{fontSize:18, fontWeight:600, color:'#333', marginBottom:10}}>Description</p>

                       <TextField
                            type="text"
                            name="description"
                            placeholder="Enter Description of food or drink"
                            value={description}
                            onChange={handleDescription}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorDescription &&

                            <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

                          }

                    </div>

                    <div style={{width:'49%', flexDirection:'column'}}>

                      <p style={{fontSize:18, fontWeight:600, color:'#333', marginBottom:10}}>Coin</p>

                      <TextField
                            // type="text"
                            name="coin"
                            placeholder="Enter Coin eg 100"
                            value={coin}
                            onChange={handleCoin}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                      />

                      {
                        errorCoin &&

                        <p style={{color:'red', fontSize:15, }}>{errorCoin}</p>

                      }

                    </div>

                    <div style={{width:'49%', flexDirection:'column', position:'relative'}}>

                      <p style={{fontSize:18, fontWeight:600, color:'#333', marginBottom:10}}>Price</p>

                        <TextField
                          // type="text"
                          name="price"
                          placeholder="Enter Actual Reward Price eg N5000"
                          value={price}
                          onChange={handlePrice}
                          style={{width:'100%', backgroundColor:'#f9e3ff', width:'95%', borderWidth:0, paddingLeft:30, border:0}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        <img
                          src="../images/naira.png"
                          alt=""
                          style={{position: 'absolute', width:15, height:20, left:20, top:50}}
                          resizeMode = "contain"
                        />

                        {
                          errorPrice &&

                          <p style={{color:'red', fontSize:15, }}>{errorPrice}</p>

                        }

                    </div>

                  
                    {/* <div style={{width:'49%', flexDirection:'column'}}>

                      <TextField
                          // type="text"
                          name="width"
                          placeholder="Enter Image Width eg 60"
                          value={width}
                          onChange={handleWidth}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorWidth &&

                          <p style={{color:'red', fontSize:15, }}>{errorWidth}</p>

                        }

                    </div>

                    <div style={{width:'49%', flexDirection:'column'}}>

                      <TextField
                          // type="text"
                          name="height"
                          placeholder="Enter Image height eg 80"
                          value={height}
                          onChange={handleHeight}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorHeight &&

                          <p style={{color:'red', fontSize:15, }}>{errorHeight}</p>

                        }

                    </div> */}

{/* imgtypeList */}


                    <div style={{width:'100%', flexDirection:'column'}}>

                    <p style={{fontSize:18, fontWeight:600, color:'#333', marginBottom:10}}>Image Type</p>

                    <div style={{width:'46%', flexDirection:'column', backgroundColor:'#f9e3ff', padding:20}}>

                      


                      {

                        imgtypeList.map((item, index) => (

                          <div style={{display:'flex', gap:10, alignItems:'center', margin:10, marginBottom:20}}>

                              <p style={{width:100}}>{item.title}</p>

                              <div key={index} onClick={() => setImgtype(item.name)} style={{display:'flex', width:26, height:26, border: '3px solid #da96f1',  borderRadius:16}}>

                                  {item.name === imgtype ? <CheckIcon sx={{ fontSize: 24, color:'#9900CC', fontWeight:800 }}/> : ""}

                              </div>

                          </div>

                           
                          
                        ))

                      }


                      {
                        errorHeight &&

                        <p style={{color:'red', fontSize:15, }}>{errorHeight}</p>

                      }

                    </div>

                    </div>
                
                </div>


                <hr style={{width:'100%', height:0, color:'$eee'}}/>


                <div style={{display: 'flex', width:'100%', flexDirection:'row', justifyContent:'space-between'}}>

               


                   <div style={{display:'flex', width:'49%'}}>

                    {

                     ( activefile && !imgactive)
                       
                    &&

                      <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
                      }}>

                      <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

                      </div>

                    }

                    {

                      (imgactive && activefile)
                      
                      &&

                      <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>


                      <img
                        src={URL.createObjectURL(activefile) }
                        alt=""
                        // className='imgs'
                        style={{width:160, height:200, cursor:'pointer'}}
                        resizeMode = "contain"
                      />

                      <Button onClick={deleteactiveImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

                      </div>

                      }


                      {

                      (!imgactive && !activefile)

                      &&

                      <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
                        <label htmlFor='activefile'>
                        {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
                        <img
                        src="../images/cloud.png"
                        alt=""
                        style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
                        // className='imgs'
                        resizeMode = "contain"
                      />

                       <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload active Loyalty Reward Image</p>
                        </label>
                       
                         {/* <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p> */}
                        <input type="file" id="activefile" onChange= {e => setactivefile(e.target.files[0])} style={{display:'none'}}/>
                      </div>



                      }

                      
                  </div>


                  <div style={{display:'flex', width:'49%'}}>

                    {

                     ( inactivefile && !imginactive)
                       
                    &&

                      <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
                      }}>

                      <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

                      </div>

                    }

                    {

                      (imginactive && inactivefile)
                      
                      &&

                      <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>

                      <img
                        src={URL.createObjectURL(inactivefile) }
                        alt=""
                        // className='imgs'
                        style={{width:160, height:200, cursor:'pointer'}}
                        resizeMode = "contain"
                      />

                      <Button onClick={deleteinactiveImage } style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

                      </div>

                      }


                      {

                      (!imginactive && !inactivefile)

                      &&

                      <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
                        <label htmlFor='inactivefile'>
                        {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
                        <img
                        src="../images/cloudinactive.png"
                        alt=""
                        style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
                        // className='imgs'
                        resizeMode = "contain"
                      />

                       <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload Inactive Loyalty Reward Image</p>
                        </label>
                       
                         {/* <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p> */}
                        <input type="file" id="inactivefile" onChange= {e => setinactivefile(e.target.files[0])} style={{display:'none'}}/>
                      </div>

                      }

                      
                  </div>


                  


                </div>


                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handleRewards} 
                    disabled={perc !== null && perc < 100}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading' : 'Upload Loyalty Reward'}
                    
                  </Button>


               


          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New
